// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"SearchCompo_inputSearch__vIU4N","input-elevated":"SearchCompo_input-elevated__13PjK"};